import get from "lodash/get";

const key = process.env.REACT_APP_TOKEN_KEY ? process.env.REACT_APP_TOKEN_KEY : "TOKEN";

const AuthStorage = {
  setLocalAuthToken: function (value: Object) {
    localStorage.setItem(key, JSON.stringify(value));
  },

  setSessionAuthToken: function (value: Object) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },

  getLocalAuthToken: function () {
    let storageData = localStorage.getItem(key);
    let result = {};
    if (storageData !== null && storageData !== undefined) {
      result = JSON.parse(storageData);
    }
    return result;
  },

  getSessionAuthToken: function () {
    let sessionData = sessionStorage.getItem(key);
    let result = {};
    if (sessionData !== null && sessionData !== undefined) {
      result = JSON.parse(sessionData);
    }
    return result;
  },

  removeLocalAuthToken: function () {
    localStorage.removeItem(key);
  },

  removeSessionAuthToken: function () {
    sessionStorage.removeItem(key);
  },

  getToken: function () {
    let token = "";
    let localData = this.getLocalAuthToken();
    let sessionData = this.getSessionAuthToken();
    if (get(localData, "access_token", "").length) {
      token = get(localData, "access_token", "");
    }
    if (get(sessionData, "access_token", "").length) {
      token = get(sessionData, "access_token", "");
    }
    return token;
  },
};

export default AuthStorage;
